import { KeyFrame } from '../../../types/prosentvis-bilde'
import { getEasing } from './easing-functions'

export function calculateValue(keyframes: KeyFrame[], percent: number): number {
  let indexOfNext = keyframes.findIndex((keyframe) => keyframe.percent >= percent)

  if (indexOfNext === -1) {
    indexOfNext = keyframes.length
  }

  const indexOfPrev = indexOfNext - 1
  const prev = keyframes[indexOfPrev]
  const next = keyframes[indexOfNext]

  if (!prev && next) {
    return next.value
  } else if (prev && !next) {
    return prev.value
  } else if (prev && next) {
    if (prev.percent === next.percent) {
      return prev.value
    }

    const dist = next.percent - prev.percent
    const pos = percent - prev.percent
    const easingFunction = getEasing(prev.easing)
    const t = easingFunction(pos / dist)
    return interpolate(prev.value, next.value, t)
  }

  return 0
}

export function interpolate(a: number, b: number, t: number) {
  return t * b + (1 - t) * a
}
